/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ClubsControllerListClubsV1SortOrder = typeof ClubsControllerListClubsV1SortOrder[keyof typeof ClubsControllerListClubsV1SortOrder];


export const ClubsControllerListClubsV1SortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;
